import React, { useState, useEffect, createContext } from "react";
import * as Storage from "ts-storage";
import { getDataFromToken } from "./AuthAPI";

export interface FlashMessageProp {
  type: string;
  show: boolean;
  msg: string;
}

export const AuthContext = createContext<any>([]);

export const AuthProvider: React.FC<{ children: any }> = ({ children }) => {
  const [isAuth, setAuth] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [currentUser, setCurrentUser] = useState<any>(null);
  const [flashMessage, setFlashMessage] = useState<FlashMessageProp>({
    type: "",
    show: false,
    msg: "",
  });

  useEffect(() => {
    let fallback = "falsetoken";
    const token = Storage.get("token", fallback).value;

    if (token !== fallback) {
      getDataFromToken(token).then((user) => {
        if (user) {
          if (user.user_info === null) {
            user.user_info = {
              phone_number: "081xxxxxxxx",
              address: "Change your address now",
            };
          }
          setAuth(true);
          setCurrentUser(user);
          setLoading(false);
        } else {
          Storage.remove("token");
          setAuth(false);
          setCurrentUser(null);
          setLoading(false);
        }
      });
    } else {
      setAuth(false);
      setCurrentUser(null);
      setLoading(false);
    }

    if (flashMessage.show) {
      setTimeout(() => {
        setFlashMessage({
          type: "",
          msg: "",
          show: false,
        });
      }, 2000);
    }
  }, [flashMessage.show]);

  return (
    <AuthContext.Provider
      value={[
        isAuth,
        setAuth,
        currentUser,
        setCurrentUser,
        flashMessage,
        setFlashMessage,
        loading,
        setLoading,
      ]}
    >
      {children}
    </AuthContext.Provider>
  );
};
